import { isNil, isEmpty, get } from "lodash";
import request from "@ali/request-olympics";
import Base from "./_Base";
import { transformUrl } from '../../adapter/request';
import * as fieldParser from "./parses/field";

// 出生地变更获取医院列表
// request: [
//   {
//     requestId: 'UUID',
//     action: "/toc/form/obtainDatasourceData",
//     params: {
//       // 目标 id
//       entityCode:"areaHospital",
//       bizCode: "${self.csdd}.value.last"
//     },
//     type: "POST",
//     event: "${self.csdd}:change",
//     field: {
//       id: "self.yljgmc",
//       prop: "dataSource.options"
//     }
//   }
// ]

// 支持 组件 props 事件函数
// {
//   "requestId": "COND_HOUSING_FUND",
//   "action": "/form/commonRuleCheck",
//   "params": {
//     "ruleType": "COND_HOUSING_FUND",
//     "expectValue": "500000",
//     "self.NAME": "${self.NAME}.value",
//     "self.IDCARD": "${self.IDCARD}.value",
//     "self.TQJE": "${self.TQJE}.value"
//   },
//   "type": "POST",
//   "disableParamsEvent": true,
//   "event": "${self.NAME}:onBlur, ${self.IDCARD}:onBlur, ${self.IDCARD}:onBlur",
//   "target": {
//     "self.TQJE": {
//       "props": {
//         "hasError": "!${res}.success",
//         "errorMsg": "!${res}.errorMsg"
//       }
//     }
//   }
// }

export default class Request extends Base {
  _type = "request";

  /**
   * 解析影响字段
   * @param {object} field 影响字段
   */
  _parseField(field) {
    return fieldParser.parse(field, {
      fieldApi: this.fieldApi,
      funcs: this.funcs,
    });
  }

  parse = () => {
    const { request: dataSource } = this.schema;
    if (!dataSource || !dataSource.length) return;

    dataSource.forEach((item) => {
      const {
        requestId,
        action: url,
        type: method,
        disableParamsEvent, // 禁止从 params 中解析出事件
        overwrite,
      } = item;
      const parsedEvent = this._parseEvent(item.event);
      const parsedParams = this._parseParams(item.params);
      let parsedAction = {};
      if (item.field) {
        parsedAction = this._parseField(item.field);
      } else if (item.target) {
        parsedAction = this._parseTarget(item.target, { overwrite });
      }
      const { preHandler, handler, modalShowEvent = {} } = parsedAction;
      const event = disableParamsEvent
        ? this._mergeEvent(parsedEvent.event, modalShowEvent)
        : this._mergeEvent(
          parsedEvent.event,
          parsedParams.event,
          modalShowEvent
        );
      this._addListener({
        uuid: requestId,
        config: item,
        event,
        func: ({ value, changedKey, initial } = {}, others = {}) => {
          // getRunFuncFlag 函数用于额外控制是否执行 func，默认runFuncFlag=true
          const flag =
            others && typeof others.getRunFuncFlag === "function"
              ? others.getRunFuncFlag(item)
              : true;
          if (!flag) {
            return;
          }

          const params = parsedParams.handler(item);
          if (!params) return;

          const {
            cardSubBlurEvt = false,
            cardFieldId,
            cardCurRowData = {},
            cardChangedKey = {},
            cardRowIndex,
          } = others || {};

          // 卡片脱敏事件参数特殊处理，将requestUniqueKey脱敏标识替换成需要的值
          if (cardSubBlurEvt && cardFieldId && item.params.requestUniqueKey) {
            changedKey = cardChangedKey || changedKey;
            const matches = item.params.requestUniqueKey.match(
              /\${([^}]*)}\.rowData\.(.*)$/
            );
            if (
              matches &&
              matches.length &&
              matches[1] &&
              matches[2] &&
              cardFieldId === matches[1] &&
              typeof cardCurRowData[matches[2]] !== "undefined"
            ) {
              params.requestUniqueKey = cardCurRowData[matches[2]];
              params.rowIndex = cardRowIndex;
            }
          } else {
            // 避免触发缺少必要参数的脱敏请求
            if (
              (item.allowEmptyParam ||
                (item.allowedEmptyParams || []).includes("requestUniqueKey")) &&
              item.params.requestUniqueKey &&
              !params.requestUniqueKey
            ) {
              return;
            }
          }

          const {
            sequenceNo = params.sequenceNo || "",
            matterId = params.matterId || "",
            matterType = params.matterType || "",
            access_token = params.access_token || "",
            auth_type = params.auth_type || "",
          } = this.params || {};

          // 预处理
          // eslint-disable-next-line no-unused-expressions
          preHandler && preHandler();
          this.updateRequestCounter(true);
          request(transformUrl(url), {
            method,
            type: "",
            contentType: "application/json",
            timeout: 60000,
            headers: {
              access_token,
              auth_type,
            },
            data: {
              ...params,
              requestId,
              sequenceNo,
              matterId,
              matterType,
              ...get(others || {}, "rowRecord", {}), // 增加大表格rowRecord参数
              ...changedKey,
            },
          })
            .then((res) => {
              if (res && res.success && !isNil(res.data)) {
                // 运行时构建响应数据并传入
                return handler({
                  res: res.data,
                  failed: isEmpty(res.data),
                  changedKey,
                  initial,
                });
              }

              return handler({ res: undefined, failed: true });
            })
            .catch((e) => {
              console.warn("Request error", e);
              handler && handler({ res: undefined, failed: true });
            })
            .finally(() => {
              this.updateRequestCounter(false);
            });
        },
      });
    });
  };
}
